import { ready } from '../utils/readyinit';
import initProductVariants from '../components/product-variants';
import initAtcForm from '../components/atcForm';
import initProductStrengthModal from '../components/product-strength-modal';
import initMdiModal from '../components/mdi-modal.js';
import initProductConsultationModal from '../components/product-consultation-modal';
import initProductAccordionVideo from '../components/product-accordion-video';
import initProductGalleryVideo from '../components/product-gallery-video';

ready(() => {
  initProductVariants();
  initAtcForm();
  initProductStrengthModal();
  initMdiModal();
  initProductConsultationModal();
  initProductAccordionVideo();
  initProductGalleryVideo();
});
